import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        '& p': {
            fontSize: '13px !important'
        }
    }
}))